/**
 * @enum {enumAlertType} Represents different possible types of alerts
 */
export enum enumAlertType {
  None = 'None',
  Error = 'Error',
  Info = 'Info',
  Success = 'Success',
  Warning = 'Warning'
}